import { Carousel } from 'antd';
import styled from 'styled-components';


export const ProgressWrapper = styled.div`
  width: 50%;
  margin: auto;
  display: inline-block;
`;

export const Slide = styled.div`
  color: #fff;
  lineHeight: 160px;
  textAlign: center;
  background: #364d79;
  padding: 10px;
  .ant-image {
    // height: 550px;
    overflow: hidden;
  }
`;

export const StyledCarousel =  styled(Carousel)`
  // height: 580px;
  margin: 10px auto;
  width: 70%;
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
`;
